import requestor from "shared/service/requestor";

export default class HomeworkInstanceApi {
  try = {
    all({ courseId, lessonId }, homeworkId = null, clientId = null) {
      return requestor.get("/course/homework_instance_try_all", {
        course_id: courseId,
        lesson_id: lessonId,
        homework_id: homeworkId,
        client_id: clientId,
      });
    },
    clientView({ courseId, lessonId }, homeworkId, clientId) {
      return requestor.get("/course/homework_instance_try_client_view", {
        course_id: courseId,
        lessonId: lessonId,
        homework_id: homeworkId,
        client_id: clientId,
      });
    },
    performModeration({ courseId, lessonId }, tryId, newStatus, comment) {
      return requestor.patch("/course/homework_instance_try_perform_moderation", {
        course_id: courseId,
        lesson_id: lessonId,
        try_id: tryId,
        new_status: newStatus,
        comment: comment,
      });
    },
    comment: {
      all({ courseId, lessonId }, homeworkTryId) {
        return requestor.get("/course/homework_instance_try_comment_all", {
          course_id: courseId,
          lesson_id: lessonId,
          id: homeworkTryId,
        });
      },
    },
  };
}
